import $ from 'jquery';


export default class SlickSlider {
    init() {
        $('[data-slick]').not('.slick-initialized').each(function() {
            let self = $( this );
            if(self.data('count') === 1){
                return;
            }

            self.slick({
                prevArrow:"<button type=\"button\" class=\"btn btn-link slick-prev slick-arrow\" aria-label=\"Prev\"><i class=\"material-icons left\">&#xE314;</i></button>",
                nextArrow:"<button type=\"button\" class=\"btn btn-link slick-next slick-arrow\" aria-label=\"Next\"><i class=\"material-icons right\">&#xE315;</i></button>",
                speed: 100
                });
        });
    }

}

$(document).ready(() => {
    $('.secondary-products-slider').slick({
        slidesToShow: 4,
        prevArrow:'<button type="button" class="btn btn-link slick-prev slick-arrow" aria-label=\"Prev\"><svg xmlns="http://www.w3.org/2000/svg" width="9.489" height="18.271" viewBox="0 0 9.489 18.271"><g transform="translate(9.135 17.917) rotate(180)"><line x2="8.782" y2="8.782" fill="none" stroke="#707070" stroke-width="1"/><line x1="8.782" y2="8.782" transform="translate(0 8.782)" fill="none" stroke="#707070" stroke-width="1"/></g></svg></button>',
        nextArrow:'<button type="button" class="btn btn-link slick-next slick-arrow" aria-label=\"Next\"><svg xmlns="http://www.w3.org/2000/svg" width="9.489" height="18.271" viewBox="0 0 9.489 18.271"><g transform="translate(0.354 0.354)"><line x2="8.782" y2="8.782" fill="none" stroke="#707070" stroke-width="1"/><line x1="8.782" y2="8.782" transform="translate(0 8.782)" fill="none" stroke="#707070" stroke-width="1"/></g></svg></button>',
        speed: 100,
        infinite: false,
        responsive: [ 
            {
              breakpoint: 1320,
              settings: {
                slidesToShow: 3
              }
            },
            {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false,
                  dots: true
                }
            }
          ]
    });

    $('.elementor-image-carousel').on('init breakpoint', function(slick){ 
      var carouselOptions = {
          prevArrow:'<svg xmlns="http://www.w3.org/2000/svg" width="9.489" height="18.271" viewBox="0 0 9.489 18.271"><g transform="translate(9.135 17.917) rotate(180)"><line x2="8.782" y2="8.782" fill="none" stroke="#707070" stroke-width="1"/><line x1="8.782" y2="8.782" transform="translate(0 8.782)" fill="none" stroke="#707070" stroke-width="1"/></g></svg>',
          nextArrow:'<svg xmlns="http://www.w3.org/2000/svg" width="9.489" height="18.271" viewBox="0 0 9.489 18.271"><g transform="translate(0.354 0.354)"><line x2="8.782" y2="8.782" fill="none" stroke="#707070" stroke-width="1"/><line x1="8.782" y2="8.782" transform="translate(0 8.782)" fill="none" stroke="#707070" stroke-width="1"/></g></svg>',
      }
      $('.home-brand-carousel .elementor-image-carousel .slick-arrow.slick-prev').html(carouselOptions.prevArrow);
      $('.home-brand-carousel .elementor-image-carousel .slick-arrow.slick-next').html(carouselOptions.nextArrow);
      $(this).css({
          'opacity': '1',
          'height': 'auto'
      });
  });

   $('.slick-slider').on('init afterChange', function(event, slick){
        slick.$slides.removeAttr('aria-hidden');
    });
    
}); 
